import React from "react";
import { Link } from "react-router-dom";
import { BreadCrumb, BreadCrumbProp } from "../../../../components/light/Breadcrumb";
import { Content } from "../../../../components/light/Content";
import { SectionBlock } from "../../../../components/light/SectionBlock";
import { InlineTabContentProduct, InlineTabProduct } from "./components/InlineTabProduct";
import { ProductList } from "./components/ProductList";

const BreadCrumbItems: BreadCrumbProp[] = [
  {
    text: "Applications",
    to: "#",
  },
  {
    text: "Products",
    to: "#",
  },
  {
    text: "List",
    to: "/products/items",
  },
];

interface Props {
  history: any;
  location: any;
}

export class ProductListScreen extends React.Component<Props> {
  state: {
    status: "APPROVED" | "DRAFTING" | "REJECT" | any;
  };

  constructor(props: Props) {
    super(props);
    const query = new URLSearchParams(this.props.location.search);
    const status = query.get("filter") === null ? "APPROVED" : query.get("filter");
    if (query.get("filter") === null) {
      this.props.history.replace({
        pathname: "/products/items",
        search: "?filter=APPROVED",
      });
    }
    this.state = {
      status,
    };
  }

  // componentDidMount() {
  //   document.getElementById("DesktopMenu")!.className =
  //     "min-full-height menu-w color-scheme-dark color-style-bright menu-position-side menu-side-left menu-layout-mini sub-menu-style-over sub-menu-color-bright selected-menu-color-light menu-activated-on-hover menu-has-selected-link";
  // }

  // componentWillUnmount() {
  //   document.getElementById("DesktopMenu")!.className =
  //     "min-full-height menu-w color-scheme-light color-style-transparent menu-position-side menu-side-left menu-layout-compact sub-menu-style-over sub-menu-color-bright selected-menu-color-light menu-activated-on-hover menu-has-selected-link";
  // }

  render() {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <SectionBlock title="Product List" transparent={true}>
          <Link to="/product/upload" className="btn btn-secondary btn-sm">
            Upload Product
          </Link>
          <br />
          <br />
          <InlineTabProduct contentChildren={<ProductList status={this.state.status} {...this.props} />}>
            <InlineTabContentProduct
              actived={this.state.status === "APPROVED"}
              alias="?filter=APPROVED"
              onClick={(alias) => this.setState({ status: "APPROVED" })}
            >
              <i className="far fa-vote-yea" /> &nbsp;Approved
            </InlineTabContentProduct>
            <InlineTabContentProduct
              actived={this.state.status === "DRAFTING"}
              alias="?filter=DRAFTING"
              onClick={(alias) => this.setState({ status: "DRAFTING" })}
            >
              <i className="far fa-eye" /> &nbsp; Reviewing
            </InlineTabContentProduct>
            <InlineTabContentProduct
              actived={this.state.status === "REJECT"}
              alias="?filter=REJECT"
              onClick={(alias) => this.setState({ status: "REJECT" })}
            >
              <i className="far fa-vote-nay" /> &nbsp;Rejected
            </InlineTabContentProduct>
            <InlineTabContentProduct
              actived={this.state.status === "INCOMPLETE"}
              alias="?filter=INCOMPLETE"
              onClick={(alias) => this.setState({ status: "INCOMPLETE" })}
            >
              <i className="fas fa-remove-format" /> &nbsp;Incomplete
            </InlineTabContentProduct>
            <InlineTabContentProduct
              actived={this.state.status === "DUPLICATED"}
              alias="?filter=DUPLICATED"
              onClick={(alias) => this.setState({ status: "DUPLICATED" })}
            >
              <i className="far fa-copy" /> &nbsp;Duplicated
            </InlineTabContentProduct>
          </InlineTabProduct>
        </SectionBlock>
      </Content>
    );
  }
}
